/*Pass a function to be debounced
 * A debounced function will be called only after *delay* milliseconds, with last arguments passed */
export function debounce(func, delay) {
  let inDebounce
  return function () {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
  }
}

/*Pass a function to be throttleed
 * A throttleed function will be called once every *limit* milliseconds, every extra calls will be ignored */
export function throttle(func, limit) {
  let inThrottle
  return function () {
    const args = arguments
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => (inThrottle = false), limit)
    }
  }
}
